// This file is automatically generated. DO NOT EDIT.

import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetUserProfilesResponse {
  /** The type of org of the user */
  organizationType: string;
  /** The size of the org of the user */
  organizationSize: string;
  /** The department the user works in */
  department: string;
  /** The work role of the user */
  workRole: string;
  /** The user initial goal */
  userInitialGoal: string;
}

export async function getUserProfilesResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetUserProfilesResponse>,
): Promise<GetUserProfilesResponse> {
  return getJSONResponse<GetUserProfilesResponse>(
    response,
    'getUserProfilesResponse',
    options,
  );
}
